<template>
    <div v-if="!isWeixin" class="sq-notice">
        <div class="weui-msg">
            <div class="weui-msg__icon-area">
                <i class="el-icon-warning" style="color: #2b94ff;font-size:100px">
                </i>
            </div>
            <div class="weui-msg__text-area">
                <h2 class="weui-msg__title">温馨提示</h2>
                <p class="weui_msg__desc">{{notice}}</p>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="spxqy">
            <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
            </van-nav-bar>
        </div>
        <div :style="{opacity: opacity}" v-if="opacity>0" class="nav">
            <div class="header-new-title">
                <nav class="detail_anchor">
                    <span class="dhbt" type="goods" :class="{'active1': currentTab=='goods'}"
                          @click="onScrollGoods"><span>商品信息</span></span>
                    <span class="dhbt" type="con" :class="{'active1': currentTab=='con'}"
                          @click="onScrollCon"><span>内容介绍</span></span>
                    <span class="dhbt" type="miaoshu" :class="{'active1': currentTab=='miaoshu'}"
                          @click="onScrollMiaoshu"><span>图文详情</span></span>
                    <span class="dhbt" type="wypj" :class="{'active1': currentTab=='wypj'}"
                          @click="onScrollWypj"><span>网友评价</span></span>
                </nav>
            </div>
        </div>
        <div style="padding-top: 50px">
            <div class="goods">
                <div>
                    <van-swipe :autoplay="3000" :height="this.screenWidth" :width="this.screenWidth"
                               indicator-color="white">
                        <van-swipe-item spu>
                            <van-image :src="spu.imgUrl"/>
                        </van-swipe-item>
                    </van-swipe>
                </div>
                <div class="ms-info">
                    <div style="display:flex;;flex-direction: row;align-items: center">
                        <i class="el-icon-alarm-clock" style="font-size: 23px;color: #ffffff"></i>
                        <span style="font-size: 15px;display: block;color: #ffffff;margin-left: 5px">限时商品</span>
                    </div>
                    <div>
                        <van-count-down millisecond :time="spu.msNo" format="HH:mm:ss">
                        </van-count-down>
                    </div>
                </div>
                <van-cell-group custom-class="goods-cell-group">
                    <van-cell custom-class="goods-express" style="padding: 3px 17px;">
                        <van-col span="10">
                            <span style="height: 20px;color: #ff4d51;font-size: 18px">¥{{spu.spikePrice}}</span>
                            <span class="jg-span">{{spu.originalPrice}}</span>
                        </van-col>
                        <van-col span="14" style="text-align: right;font-size: 10px;color: #888888">
                            已售 {{spu.sale}}
                        </van-col>
                    </van-cell>
                    <van-cell
                            custom-class="goods-message"
                            :title="spu.msName"
                            :label="spu.introduce"
                            style="padding: 3px 17px;margin-top: -8px;"
                    >
                    </van-cell>
                </van-cell-group>
                <van-cell-group custom-class="goods-cell-group">
                    <van-cell icon="shop-o" is-link @click="toMds">
                        <span style="font-size: 12px">查看可用门店</span>
                    </van-cell>
                </van-cell-group>
                <van-cell-group custom-class="goods-cell-group">
                    <van-coupon-cell
                            icon="coupon-o"
                            :coupons="coupons"
                            :chosen-coupon="chosenCoupon"
                            @click="showList = true"
                            style="font-size: 12px"
                    />
                </van-cell-group>
                <div class="liulan1">
                    <div class="liulan">
                        <div class="liulan-num">
                            <div class="liulan-num-item">
                                <span style="font-size: 18px;color: #E5A3D0">{{spu.browse}}</span>
                                <span style="font-size: 13px;margin-top: 5px;color:#92949A;">浏览量</span>
                            </div>
                            <div class="liulan-num-item" style="margin-right: 5px">
                                <span style="font-size: 18px;color: #64488B">{{spu.sale}}</span>
                                <span style="font-size: 13px;margin-top: 5px;color:#92949A;">参加人数</span>
                            </div>
                        </div>
                        <div class="liulan-lunbo">
                            <van-swipe :autoplay="3000" width="100%" height="400px" indicator-color="white">
                                <van-swipe-item v-for="item in maps">
                                    <div style=" display: flex; flex-flow: row wrap;;padding-bottom: 10px">
                                        <div v-for="it in item.list" class="img-list">
                                            <img v-if="it.headPortrait" :src="it.headPortrait"
                                                 style="width: 50px;height: 50px;border-radius: 35px">
                                            <img v-if="!it.headPortrait&&it.sex==1" src="../../assets/nan.png"
                                                 style="width: 50px;height: 50px;border-radius: 35px">
                                            <img v-if="!it.headPortrait&&it.sex==2" src="../../assets/nv.png"
                                                 style="width: 50px;height: 50px;border-radius: 35px">
                                        </div>
                                    </div>
                                </van-swipe-item>
                            </van-swipe>
                        </div>
                    </div>
                </div>
            </div>
            <div class="con" ref="con" id="con">
                <div style="width: 95%;margin:auto;">
                    <span style="font-size: 13px;color: #dddddd;display:block;text-align: center;margin-bottom: 8px;margin-top: 8px">- 使用说明( {{spu.kxTitle}} ) -</span>
                    <div style="display: flex;flex-direction: column;font-size: 13px;border: #dddddd solid 1px;margin-bottom: 12px"
                         v-for="it in msiList">
                        <div style="height: 25px;line-height: 25px;background-color: #FAF1E9;display: flex;flex-direction: row;font-size: 12px">
                            <span style="width: 47%;padding: 0px 8px">{{it.itemName}}</span>
                            <span style="width: 26%;padding: 0px 8px;text-align: right">{{it.quantity+'份/RMB'}}</span>
                            <span style="width: 26%;padding: 0px 8px;text-align: center">¥ {{it.quantity*it.price}}</span>
                        </div>
                        <div style="padding: 15px">
                            <div class="liucheng" v-if="it.itemType==0||it.itemType==3||it.itemType==4">
                                <div class="gongxiao">
                                    <span style="width: 70px">服务时长:</span>
                                    <span style="width: 80%;padding-left: 18px">{{it.serviceTime}}</span>
                                </div>
                                <div class="gongxiao" style="margin-top: 28px">
                                    <span style="width: 70px;line-height: 20px">流程说明：</span>
                                    <div style="width: 80%">
                                        <div v-for="st in it.steps" class="stepitem">
                                            <div class="stepname">
                                                <div class="yaundian"></div>
                                                <span>{{st.name}}</span>
                                            </div>
                                            <span class="stepms">{{st.con}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="gongxiao" v-else>
                                <span style="flex: 0 0 15%;">功效:</span>
                                <span style="flex: 0 0 85%; overflow: hidden; word-break: break-all;">{{it.note}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="miaoshu" ref="miaoshu" id="miaoshu">
                <div style="width: 95%;margin:auto;">
                <p v-html="spu.description"></p>
                </div>
            </div>
            <div class="wypj" ref="wypj">
                <span style="font-size: 13px;display: block;text-align: center">暂无评价</span>
            </div>
        </div>
        <div>
            <div>
                <van-goods-action>
                    <van-goods-action-icon icon="chat-o" text="客服" @click="onClickIcon"/>
                    <van-goods-action-button type="danger" text="立即购买" @click="toSpec('GM')" style="width: 100px;"/>
                </van-goods-action>
            </div>
            <van-popup v-model="mdShow" position="bottom">
                <div style="height: 380px;background-color: #EEEEEE">
                    <div class="ms-mds">
                        <span>适用门店</span>
                        <span>
                        <i class="el-icon-circle-close" style="font-size: 23px" @click="gbmds"></i>
                    </span>
                    </div>
                    <div class="md-items" v-for="item in mds">
                        <div class="md-item">
                            <span><i class="el-icon-s-shop"></i></span>
                            <span style="margin-left: 8px">{{item.deptName}}</span>
                        </div>
                        <div class="md-item">
                            <span><i class="el-icon-location-information"></i></span>
                            <span style="margin-left: 8px">{{item.address}}</span>
                        </div>
                        <div class="md-item">
                            <span><i class="el-icon-phone-outline"></i></span>
                            <span style="margin-left: 8px">{{item.phone}}</span>
                        </div>
                    </div>
                </div>
            </van-popup>
            <van-popup v-model="show" position="bottom" closeable lock-scroll overlay round
                       style="height: 66%;">
                <div class="specs">
                    <div class="sku-info">
                        <img :src="spu.imgUrl"/>
                        <div style="display: flex;flex-direction: column;justify-content: center;padding-left: 12px">
                            <span style="font-size: 13px">{{spu.msName}}</span>
                            <span style="color: #ff4d51;font-size: 12px;margin-top:8px">¥{{spu.spikePrice}} <span
                                    class="jg-span">{{spu.originalPrice}}</span></span>
                        </div>
                    </div>
                    <div class="sku-spec">
                        <span style="font-size: 13px;color: #dddddd;display:block;text-align: center;margin-bottom: 3px;">- 使用说明( {{spu.kxTitle}} ) -</span>
                        <div style="margin-bottom: 55px;">
                            <van-cell-group custom-class="goods-cell-group">
                                <van-cell :border="false">
                                    <div style="display: flex;flex-direction: row;justify-content:space-between;margin: 5px 0px"
                                         v-for="item in msiList">
                                        <span style="font-size: 12px">{{item.itemName}}</span>
                                        <span style="font-size: 12px;width: 60px">X {{item.quantity}} 份</span>
                                        <van-stepper min="0" :max="item.quantity" v-model="item.total" :disabled="jynum"
                                                     style="width: 120px"/>
                                    </div>
                                </van-cell>
                            </van-cell-group>
                        </div>
                    </div>
                </div>
                <div class="d-btn">
                    <van-button size="large" class="spec-btn1" @click="setSku" style="background-color: #F04569">立即购买
                    </van-button>
                </div>
            </van-popup>
            <div id="box" class="box">
                <transition name="mybox" mode="out-in">
                    <div class="caidan" v-show="boxshow">
                        <div style="padding-top: 8px" v-if="boxshow">
                            <div class="caidan-btn" @click="toHome">
                                <i class="el-icon-s-home"></i>
                                <span>首页</span>
                            </div>
                            <div class="caidan-btn" @click="toMy">
                                <i class="el-icon-user"></i>
                                <span>个人</span>
                            </div>
                            <div class="caidan-btn" @click="toPoster(spu)">
                                <i class="el-icon-news"></i>
                                <span>海报</span>
                            </div>
                        </div>
                        <div class="cha">
                            <i @click="togglebox" class="el-icon-close">
                            </i>
                        </div>
                    </div>
                </transition>
                <div class="box-btn" @click="togglebox">
                    <i class="el-icon-arrow-up" style="font-size: 20px;margin-top: -5px;color:#92949A;"></i>
                    <p style="font-size: 10px;color:#92949A;">导航</p>
                </div>
            </div>
            <van-popup v-model="showPoster">
                <div id="imageWrapper1">
                    <div class="content_container">
                        <vue-canvas-poster v-if="!posterImg" :widthPixels="900" :heightPixels="1600"
                                           :painting="painting"
                                           @success="success" @fail="fail">
                        </vue-canvas-poster>
                        <van-image :src="posterImg" id="mypic" class="hb-img" crossOrigin="anonymous"/>
                    </div>
                </div>

            </van-popup>
        </div>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName, setYqUrl} from "../../utils/auth";

    export default {
        data() {
            return {
                navTop: 0,
                currentTab: 'goods', // 当前选中的标签
                notice: '请在微信客户端打开链接!',
                isWeixin: true,

                deptId: '',
                token: '',
                title: "详情",
                spuId: '',
                spu: {},

                goodsActive: 0,

                skuNum: 0,
                chosenCoupon: -1,
                coupons: [],
                showList: false,

                showBase: true,
                showType: '',

                mdShow: false,
                show: false,

                specActive: 0,
                // adsId: '',
                addressInfo: {},

                screenWidth: '',
                mds: [],
                msiList: [],

                boxshow: false,
                maps: [],

                showPoster: false,
                posterImg: '',//生成的海报
                painting: {
                    views: []
                },
                jynum:false,

                scrollTop: 0,
                opacity: 0,
                active: 'goods',
            };
        },
        async mounted() {
            document.title = getDeptName()
            this.mid = this.$route.params.mid
            this.spuId = this.$route.params.spuId
            this.screenWidth = window.innerWidth;
            this.deptId = getDeptId()
            this.token = getCookie('spmToken')
            await this.panduan()
            if (this.isWeixin) {
                if (!this.token) {
                    setYqUrl('/fxmsDetails/' + this.deptId + '/' + this.mid + '/' + this.spuId)
                    this.$router.push('/invite/' + this.deptId + '/' + this.mid)
                }
            }
            this.saveSpBrowse()
            this.getSpmSpu()
            window.addEventListener('scroll', this.handleScroll);
            // this.hideOptionMenu()
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            hideOptionMenu(){
                this.$nextTick(() => {
                    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.call == "function") {
                        // 在微信网页浏览器内
                        WeixinJSBridge.call('hideOptionMenu');
                    } else {
                        // 在微信网页浏览器外或者WeixinJSBridge还未加载完成
                        document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
                            WeixinJSBridge.call('hideOptionMenu');
                        });
                    }
                })
            },

            handleScroll() {
                let clientHeight = document.documentElement.clientHeight;//可视高度
                let scrollHeight = document.documentElement.scrollHeight;//内容高度
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                if (scrollTop < 200) {
                    // 当滚动距离小于200时，计算导航透明度，可以考虑修改为每20增加0.1
                    // this.opacity = (scrollTop / 200).toFixed(1);
                    this.opacity = scrollTop / 200;
                    this.active = 'goods';
                    return
                } else {
                    this.opacity = 1
                }
                // 当滚动距离不小于200时，获取三个部分的顶部位置-45。
                let conTop = this.$refs.con.offsetTop - 500;
                let miaoshuTop = this.$refs.miaoshu.offsetTop - 500;
                let wypjTop = this.$refs.wypj.offsetTop - 300;
                // 计算滚动距离在哪个区间，修改this.active对应的样式名
                if (scrollTop) {
                    if (scrollTop == this.screenHeight) {
                        if (this.currentTab != 'wypj') this.currentTab = 'wypj';
                        return;
                    }
                    if (scrollTop < conTop) {
                        if (this.currentTab != 'goods') this.currentTab = 'goods';
                    } else if (scrollTop >= conTop && scrollTop < miaoshuTop) {
                        if (this.currentTab != 'con') this.currentTab = 'con';
                    } else if (scrollTop >= miaoshuTop && scrollTop < wypjTop) {
                        if (this.currentTab != 'miaoshu') this.currentTab = 'miaoshu';
                    } else if (scrollTop >= wypjTop) {
                        if (this.currentTab != 'wypj') this.currentTab = 'wypj';
                    }
                }
            },

            // 点击导航栏第一个商品选项卡时，直接滚动到0
            onScrollGoods() {
                window.scrollTo({top: 0, behavior: "smooth"});
            },
            // 点击导航栏其他选项卡时，直接滚动到对应ref的offsetTop-45(导航栏高度)
            onScrollCon() {
                if (!this.opacity) return;
                window.scrollTo({top: this.$refs.con.offsetTop - 45, behavior: "smooth"});
            },
            onScrollMiaoshu() {
                if (!this.opacity) return;
                window.scrollTo({top: this.$refs.miaoshu.offsetTop - 45, behavior: "smooth"});
            },
            onScrollWypj() {
                if (!this.opacity) return;
                //document.documentElement.scrollTop = this.$refs.detail.offsetTop - 45;
                // behavior  类型String,表示滚动行为,支持参数 smooth(平滑滚动),instant(瞬间滚动),默认值auto,实测效果等同于instant
                window.scrollTo({top: this.$refs.wypj.offsetTop - 45, behavior: "smooth"});

            },
            panduan() {
                let that = this;
                var ua = navigator.userAgent.toLowerCase(); //判断是否是微信浏览器
                var isWeixin = ua.indexOf("micromessenger") != -1; //判断是否
                this.isWeixin = isWeixin
                if (!isWeixin) {
                    return false;
                }
            },
            async saveSpBrowse() {
                // if (!this.token){
                //     return ;
                // }
                let data = {
                    token: this.token,
                    goodsId: this.spuId,
                    type: 'MS'
                }
                let res = await this.$post("/spm/saveSpBrowse", data)
                this.maps = res.maps
            },
            toHome() {
                this.$router.push('/home/' + this.deptId)
            },
            toMy() {
                this.$router.push('/my/' + this.deptId)
            },
            toHb() {
                this.$notify("生成海报出错")
            },
            togglebox: function () {
                this.boxshow = !this.boxshow;
            },

            onClickIcon() {
            },

            onClickLeft() {
                this.$router.push('/home/' + this.deptId)
            },
            toSpec() {
                if (!this.token) {
                    this.$router.push('/empower/' + this.deptId)
                    return;
                }
                this.show = true
            },

            checkedSpec(index, sku) {
                this.specActive = index
                this.sku = sku
            },

            setSku() {
                let total = 0
                var arr = []
                this.msiList.forEach(item => {
                    total = parseInt(item.total) + parseInt(total)
                    if (item.total > 0) {
                        arr.push(item)
                    }
                })
                if (parseInt(total) > this.spu.quantity) {
                    this.$toast('所选的商品数量超出' + this.spu.quantity + ',不能下单！');
                    return;
                }
                if (parseInt(total) < this.spu.quantity) {
                    this.$toast('所选的商品数量低于' + this.spu.quantity + ',不能下单！');
                    return;
                }
                this.show = false
                this.toPlusBuy(arr)
            },

            async toPlusBuy(arr) {
                let data = {
                    goodsId: this.spu.id,
                    goodsStr: JSON.stringify(arr),
                    type: 'ms',
                    token: this.token
                }
                let res = await this.$post("/spm/toRedisBuy", data)
                if (res.code == 200) {
                    this.show = false
                    this.toBuy(res.no, this.spu.id)
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },

            toBuy(no, goodsId) {
                this.$router.push('/buyMs/' + this.deptId + '/' + no + '/ms/' + goodsId)
            },

            toMds() {
                this.mdShow = true
            },
            gbmds() {
                this.mdShow = false
            },

            async getSpmSpu() {
                let res = await this.$get("/spm/getSpmMsc", {msId: this.spuId})
                this.spu = res.mscb
                this.mds = res.mssList
                this.msiList = res.msiList
                if (res.mscb.skuTotal == res.mscb.quantity) {
                    this.spu.kxTitle = '全部可选'
                    this.msiList.forEach(item => {
                        item.total = item.quantity
                        if (item.step) {
                            item.steps = JSON.parse(item.step)
                        }
                    })
                    this.jynum = true
                } else {
                    this.spu.kxTitle = res.mscb.skuTotal + '选' + res.mscb.quantity
                }
            },

            async toPoster(item) {
                this.showPoster = true
                let data = {
                    token: this.token,
                    imgUrl: item.imgUrl,
                    route: 'fxmsDetails',
                    id: item.id,
                }
                let res = await this.$post("/spm/getSpmGoodsPoster", data)
                let imgUrl = res.imgUrl
                let touxiang = res.headPortrait
                if (!touxiang) {
                    if (res.member.sex == 2) {
                        touxiang = require('./../../assets/nv.png')
                    } else {
                        touxiang = require('./../../assets/nan.png')
                    }
                }
                var spikePrice = '0'
                if (item.spikePrice) {
                    spikePrice = item.spikePrice.toString()
                }
                var originalPrice = '¥0'
                if (item.originalPrice) {
                    originalPrice = '¥' + item.originalPrice.toString()
                }
                var msName = ''
                if (item.msName) {
                    msName = item.msName
                }
                this.painting = {
                    position: 'relative',
                    width: '900px',
                    height: '1600px',
                    background: '#FFFFFF',
                    views: [
                        {
                            type: 'image',
                            url: imgUrl,
                            css: {
                                position: 'absolute',
                                top: '0%',
                                color: '#000',
                                background: '#fff',
                                width: '900px',
                                height: '900px',
                                borderWidth: '40px',
                                borderColor: '#fff',
                            },
                        },
                        {
                            type: 'image',
                            url: res.qrCode,
                            css: {
                                position: 'absolute',
                                right: '10%',
                                top: '63.7%',
                                color: '#000',
                                background: '#fff',
                                width: '210px',
                                height: '210px',
                                borderWidth: '20px',
                                borderColor: '#fff',
                            },
                        },
                        {
                            type: "text",
                            text: "- 长按识别查看 -",
                            css: {
                                top: "77%",
                                right: '5%',
                                width: "300px",
                                maxLines: 1,
                                textAlign: "center",
                                fontSize: "25px",
                                color: "#D3D3D3",
                            },
                        },
                        {
                            type: 'image',
                            url: touxiang,
                            css: {
                                position: 'absolute',
                                top: '89%',
                                left: '55%',
                                color: '#000',
                                background: '#fff',
                                width: '98px',
                                height: '98px',
                                borderRadius: '60px',
                            },
                        },
                        {
                            type: "text",
                            text: res.member.memberName,
                            css: {
                                top: "89.5%",
                                left: "67%",
                                width: "250px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "36px",
                                color: "#555555",
                            },
                        },
                        {
                            type: "text",
                            text: "推荐一个好物给你",
                            css: {
                                top: "92.5%",
                                left: "67%",
                                height: "30px",
                                padding: "5px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "28px",
                                color: "#8B8A8A",
                            },
                        },
                        {
                            type: "text",
                            text: '¥',
                            css: {
                                top: "65.5%",
                                left: "8%",
                                width: "100px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "45px",
                                color: "#EE1111",
                            },
                        },
                        {
                            type: "text",
                            text: spikePrice,
                            css: {
                                top: "64%",
                                left: "11.5%",
                                width: "300px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "68px",
                                color: "#EE1111",
                            },
                        },
                        {
                            type: "text",
                            text: originalPrice,
                            css: {
                                top: "69.5%",
                                left: "8%",
                                width: "300px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "35px",
                                color: "#999999",
                                textDecoration: 'line-through',
                            },
                        },
                        {
                            type: "text",
                            text: msName,
                            css: {
                                top: "73%",
                                left: "8%",
                                width: "500px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "45px",
                                color: "#5E5E5E",
                            },
                        },
                        {
                            type: "text",
                            text: 'PLUS会员',
                            css: {
                                top: "66%",
                                left: "31%",
                                height: "30px",
                                lineHeight: "30px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "25px",
                                color: "#ffffff",
                                background: '#3C251D',
                                padding: '5px',
                            },
                        },
                        {
                            type: "text",
                            text: '既省钱又省心',
                            css: {
                                top: "66%",
                                left: "45%",
                                height: "30px",
                                lineHeight: "30px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "25px",
                                color: "#5E5E5E",
                                padding: '5px',
                            },
                        },
                        {
                            type: 'image',
                            url: require('./../../assets/md.png'),
                            css: {
                                position: 'absolute',
                                top: '90%',
                                left: '8%',
                                color: '#000',
                                background: '#fff',
                                width: '58px',
                                height: '58px',
                            },
                        },
                        {
                            type: "text",
                            text: res.deptName,
                            css: {
                                top: "90%",
                                left: "13%",
                                width: "300px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "center",
                                fontSize: "45px",
                                color: "#8B8A8A",
                            },
                        },

                    ],
                }
            },

            // 海报生成
            success(src) {
                this.posterImg = src
            },
            fail() {

            },

            //赋值
            handleUpdateBg(row) {
                this.posterImg = ''
                this.painting.views[0].url = row.qrUrl
            },
        },
    };
</script>

<style lang="scss" scoped>

    .nav {
        height: 45px;
        width: 100%;
        background-color: #fff;
        position: fixed;
        z-index: 99;
        opacity: 999;
    }

    .detail_anchor {
        width: 100%;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        height: 44px;
        line-height: 44px;
        font-size: 14px;
        color: #666;
        box-shadow: 0 1px 6px rgba(0, 0, 0, .1);
        justify-content: space-evenly;
    }

    .header-new-title {
        height: 44px;
        font-size: 16px;
        line-height: 44px;
        text-align: center;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
        flex-direction: row;
        width: 80%;
        margin: auto;
    }

    .dhbt {
        width: 25%;
    }

    .active1 {
        color: #e4393c;
    }
    .wypj{
        padding-bottom: 50px;
    }

    .spxqy {
        overflow: scroll;
    }

    .goods-img {
        width: 100%;
        display: block;
    }

    .goods-message .van-cell__title {
        font-size: 16px;
    }

    .goods-message .van-cell__label {
        color: #f44;
    }

    .goods-express {
        color: #999;
        font-size: 12px;
    }

    .goods-express .van-cell {
        color: #999;
        font-size: 12px;
        padding: 5px 15px;
    }

    .goods-express .van-col {
        text-align: left;
    }

    .goods-cell-group {
        margin: 0 0;
    }

    .goods-cell-group .van-cell__value {
        color: #999;
    }

    .goods-tag {
        margin-left: 5px;
    }

    .goods-action {
        position: relative !important;
    }

    .jg-span {
        height: 20px;
        margin-left: 8px;
        font-size: 10px;
        text-decoration: line-through;
        color: #888888
    }

    .tab-titel {
        font-size: 12px;
    }

    ::v-deep .van-nav-bar__title {
        max-width: 60%;
        margin: 0 auto;
        color: #323233;
        font-weight: 500;
        font-size: 15px;
    }

    .specs {
        width: 95%;
        margin: auto;
        padding-top: 12px;
        height: 100%;
        overflow: hidden;
    }

    .sku-info {
        border-bottom: #BBBBBB solid 1px;
        padding-bottom: 5px;
        display: flex;
        flex-direction: row;
    }

    .sku-info img {
        width: 50px;
        height: 50px;
    }

    .sku-spec {
        display: flex;
        flex-direction: column;
        font-size: 13px;
        padding: 10px 5px;
        height: 100%;
        overflow: auto;
        padding-bottom: 65px;
        margin-top: 10px;
    }

    .spm-item {
        display: flex;
        flex-flow: row wrap;
        margin-top: 12px;
    }

    .spm-item-spec {
        box-sizing: border-box;
        height: 32px;
        margin: 4px;
        padding: 2px 26px;
        font-size: 12px;
        /*margin-bottom: 8px;*/
        display: flex;
        flex-direction: column;
        cursor: pointer;
        border: #dddddd solid 1px;
        width: calc((100% - 15px) / 2); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc((100% - 20px) / 2);
        max-width: calc((100% - 20px) / 2);
        justify-content: center;
        align-items: center;
        /*&:nth-child(4n + 4) {*/
        /*  margin-right: 0;*/
        /*}*/
    }

    .spec-active {
        color: #F0431D;
        border: #F0431D solid 1px;
    }

    .spec-btn {
        font-size: 15px;
        width: 50%;
        color: #FFFFFF;
        height: 38px;
        line-height: 38px;
    }

    .spec-btn1 {
        font-size: 15px;
        width: 100%;
        color: #FFFFFF;
        height: 38px;
        line-height: 38px;
    }

    .d-btn {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 0px;
        background-color: #FFFFFF;
        height: 38px;
    }

    .item {
        display: inline-block;
        padding: 0px 3px;
        margin-right: 3px;
        color: #000000;
        font-size: 12px;
        text-align: center;
        background-color: #ffffff;
    }

    .ms-info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background-color: #FA2F61;
        align-items: center;
        padding: 8px 12px;
    }

    .ms-mds {
        font-size: 16px;
        padding: 3px 8px;
        border-bottom: #EEEEEE solid 1px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-color: #ffffff;
    }
    .md-items {
        display: flex;
        flex-direction: column;
        padding: 8px;
        width: 98%;
        margin: auto;
        background-color: #ffffff;
        border-radius: 5px;
        margin-top: 5px;
    }

    .md-item {
        display: flex;
        flex-direction: row;
        height: 20px;
        line-height: 20px;
    }

    .md-item span {
        font-size: 13px;
    }

    .van-count-down {
        color: #000000;
        font-size: 12px;
        line-height: 15px;
        background-color: #EEEEEE;
        padding: 1px 5px;
    }

    .box {
        position: fixed;
        right: 15px;
        bottom: 60px;
        font-size: 20px;
        width: 35px;
        height: 35px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        border-radius: 30px;
        background-color: #ffffff;
        box-shadow: 0px 0px 2px 1px #CCCCCC;
    }

    .box-btn {
        font-size: 20px;
        width: 35px;
        height: 35px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 30px;
        background-color: #ffffff;
        box-shadow: 0px 0px 1px 1px #CCCCCC;
    }

    .caidan {
        height: 200px;
        width: 38px;
        position: fixed;
        bottom: 56px;
        background-color: #ffffff;
        border: #CCCCCC solid 1px;
        border-radius: 20px;
    }

    //给过渡的name加样式
    .mybox-leave-active, .mybox-enter-active {
        /*transition: all 0.5s ease;*/
    }

    .mybox-leave-active, .mybox-enter {
        height: 0px !important;
    }

    .mybox-leave, .mybox-enter-active {
        height: 200px;
    }

    .cha {
        width: 30px;
        position: absolute;
        bottom: 0px;
        font-size: 25px;
        color: #92949A;
        padding-left: 3px;
        padding-bottom: 5px;
        z-index: 10000;
        background-color: #ffffff;
        border-radius: 30px;
        margin-left: 2px;
        margin-bottom: 4px;
    }

    .caidan-btn {
        color: #92949A;
        font-size: 23px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 50px;
    }

    .caidan-btn span {
        margin-top: 2px;
        font-size: 10px;
    }

    .liulan {
        background-color: #F9EDED;
        height: 270px;
    }

    .liulan-num {
        padding: 8px 3px;
        display: flex;
        flex-direction: row;

    }

    .liulan-num-item {
        display: flex;
        flex-direction: column;
        width: 50%;
        margin: 0 5px;
        background-color: #F9F3F3;
        height: 50px;
        padding: 8px;
        align-items: center;
    }

    .liulan-lunbo {
        padding: 0px 3px;
    }

    .img-list {
        /*flex: 1;*/
        box-sizing: border-box;
        height: 50px;
        padding: 4px;
        margin: 6px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: calc((100% - 55px) / 5); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc((100% - 55px) / 5);
        max-width: calc((100% - 55px) / 5);

        &:nth-child(5n + 5) {
            margin-right: 0;
        }
    }

    .sq-index {
        overflow: hidden;
    }

    .sq-notice {
        margin: auto;
        font-size: 18px;
        text-align: center;
        margin-top: 23%;
    }

    .weui-msg {
        padding-top: 36px;
        text-align: center;
    }

    .weui-msg__icon-area {
        margin-bottom: 30px;
    }

    .weui-icon_msg {
        font-size: 93px;
    }

    .weui-icon-info {
        font-size: 23px;
        color: #10aeff;
    }

    .weui-msg__text-area {
        margin-bottom: 25px;
        padding: 0 20px;
    }

    .weui-msg__title {
        margin-bottom: 5px;
        font-weight: 400;
        font-size: 20px;
    }

    .weui_msg__desc {
        margin-top: 16px;
    }
    .hb-img {
        width: 278px;
        height: 500px;
        background-size: 100% 100%;
    }

    .stepitem {
        display: flex;
        flex-direction: column;
    }

    .stepname {
        height: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: bold;
    }

    .stepms {
        color: #999999;
        height: 16px;
        margin-left: 16px;
    }

    .yaundian {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #F799AA;
        margin-right: 10px;
    }



</style>
